// An outdated app (#82): a newer server answers this app's writes with
// HTTP 426 (codes such as APP_UPDATE_REQUIRED or UPDATE_REQUIRED). Any 426
// counts, whatever its code. Reading keeps working; a persistent banner
// asks for an update, and the write that was refused waits in the outbox
// marked "needs update" instead of being retried.
import { atom, getDefaultStore } from 'jotai';

export const UPDATE_REQUIRED_STATUS = 426;

/** Set once a 426 arrives: the server's message, kept only as a fallback. */
export const updateRequiredAtom = atom<{ message: string | null } | null>(null);

/** Whether an error (or a status) is the server asking for an update. */
export function isUpdateRequired(err: unknown): boolean {
  if (typeof err === 'number') return err === UPDATE_REQUIRED_STATUS;
  return (
    !!err &&
    typeof err === 'object' &&
    (err as { status?: unknown }).status === UPDATE_REQUIRED_STATUS
  );
}

/** Shows the update banner (and keeps it up for this visit). */
export function markUpdateRequired(message?: string | null) {
  const store = getDefaultStore();
  if (store.get(updateRequiredAtom)) return;
  store.set(updateRequiredAtom, { message: message ?? null });
}

/** The web updates itself on the next load. */
export function updateNow() {
  window.location.reload();
}
